var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "div" } },
    [
      _c("app-divider", { staticClass: "mb-30px", attrs: { label: "Geral" } }),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Unidade de Conservação: ",
                            required: true
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input",
                            class: { erro: errors.length },
                            staticStyle: { width: "100%" },
                            on: { change: _vm.setUc },
                            model: {
                              value:
                                _vm.jsonCadastro.cadastroUc.idVinculoProcessoUc,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.jsonCadastro.cadastroUc,
                                  "idVinculoProcessoUc",
                                  $$v
                                )
                              },
                              expression:
                                "jsonCadastro.cadastroUc.idVinculoProcessoUc"
                            }
                          },
                          _vm._l(_vm.ucs, function(uc) {
                            return _c("el-option", {
                              key: uc.idProcesso,
                              attrs: { label: uc.nomeUc, value: uc.idProcesso }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("app-label", { attrs: { label: "Número do processo: " } }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: true },
                model: {
                  value: _vm.jsonCadastro.cadastroUc.numeroProcesso,
                  callback: function($$v) {
                    _vm.$set(_vm.jsonCadastro.cadastroUc, "numeroProcesso", $$v)
                  },
                  expression: "jsonCadastro.cadastroUc.numeroProcesso"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("app-label", { attrs: { label: "Número do CNUC: " } }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: true },
                model: {
                  value:
                    _vm.jsonCadastro.cadastroUc.informacoesAdministrativasUc
                      .cnuc,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.jsonCadastro.cadastroUc.informacoesAdministrativasUc,
                      "cnuc",
                      $$v
                    )
                  },
                  expression:
                    "jsonCadastro.cadastroUc.informacoesAdministrativasUc.cnuc"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "mt-10px", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("app-label", { attrs: { label: "Esfera administrativa: " } }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: true },
                model: {
                  value:
                    _vm.jsonCadastro.cadastroUc.informacoesAdministrativasUc
                      .esferaAdministrativa,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.jsonCadastro.cadastroUc.informacoesAdministrativasUc,
                      "esferaAdministrativa",
                      $$v
                    )
                  },
                  expression:
                    "jsonCadastro.cadastroUc.informacoesAdministrativasUc.esferaAdministrativa"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("app-label", { attrs: { label: "Categoria do manejo: " } }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: true },
                model: {
                  value:
                    _vm.jsonCadastro.cadastroUc.informacoesAdministrativasUc
                      .categoriaManejo,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.jsonCadastro.cadastroUc.informacoesAdministrativasUc,
                      "categoriaManejo",
                      $$v
                    )
                  },
                  expression:
                    "jsonCadastro.cadastroUc.informacoesAdministrativasUc.categoriaManejo"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-625eabf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-625eabf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/cadastroRf/AppFormularioDadosGerais.vue
// module id = null
// module chunks = 